import _ from 'lodash';

import {
  SingleSelect,
  MultipleSelect,
  NumericalRangeFilter,
  NumberSpinnerFilter,
  OpenTextFilter,
  DateRangeFilter
} from '../../../components/filter';

export const filterComponentsMap = {
  NUMERIC: OpenTextFilter,
  TEXT: OpenTextFilter,
  DATE: DateRangeFilter,
  SINGLESELECT: SingleSelect,
  NUMERICRANGE: NumericalRangeFilter
};

const dateOptions = [
  {
    value: 'NextWeek',
    label: 'Next Week'
  },
  {
    value: 'NextMonth',
    label: 'Next Month'
  },
  {
    value: 'NextQuarter',
    label: 'Next Quarter'
  }
];

export const formatFilter = filter => {
  let value = filter.value;
  let label = filter.value;
  let isRollingDate;
  switch (filter.componentType) {
    case 'DATE': {
      if (filter.type === 'custom') {
        value = `${value.start}|${value.end}`;
        label = `${value.start}, ${value.end}`;
      } else {
        if (value) isRollingDate = true;
        value = value || null;
        label = filter.label;
      }
      break;
    }
    case 'NUMERICRANGE':
      label = `${value.min}, ${value.max}`;
      value = `${value.min}|${value.max}`;
      break;
    case 'MULTISELECT':
    case 'MULTIPLESELECT':
      label = value.toString(', ');
      value = value.join('|');
      break;
    default:
      break;
  }

  return {
    label,
    value,
    isRollingDate
  };
};

const translateFilter = filter => {
  let { type, value } = filter;
  if (value === null || value === undefined) {
    value = '';
  }

  let values = [];
  if (value.split) {
    values = value.split('|');
  } else if (value instanceof Array) {
    values = value;
  }

  switch (type) {
    case 'MULTISELECT':
      let label = value ? value : '';
      label =
        value instanceof Array ? value.join(', ') : value.replace(/\|/gi, ', ');

      let newValue = !value ? [] : value;

      if (!(value instanceof Array)) {
        newValue = value ? value.split('|') : [];
      }

      return {
        label,
        value: newValue
      };
    case 'custom':
      values.push(value.start);
      values.push(value.end);
    case 'DATE':
      if (values.length > 1) {
        return {
          type: 'custom',
          label: `${values[0]} - ${values[1]}`,
          value: {
            start: values[0],
            end: values[1]
          },
          options: dateOptions
        };
      } else {
        let dispLabel = '';
        if (filter.value) {
          const dtOpt = dateOptions.find(dt => dt.value === filter.value);
          dispLabel = dtOpt.label;
        }
        return {
          type: type,
          label: dispLabel,
          value: value,
          options: dateOptions
        };
      }
      break;
    case 'NUMERICRANGE':
      if (values.length > 1)
        return {
          label: `${values[0]} - ${values[1]}`,
          value: values.join('|'),
          options: {
            minRange: 1,
            maxRange: 150
          }
        };
      else
        return {
          label: `0 - ${values}`,
          //TODO - api should always return value instead of
          // fix it on client
          value: {
            max: value || 50,
            min: 1
          },
          options: {
            minRange: 1,
            maxRange: 150
          }
        };
    case 'NUMERIC':
    case 'TEXT':
    default:
      let dispLabel = value;
      if (filter.options && typeof filter.options === 'object') {
        const selOpt = filter.options.find(opt => opt.value === value);
        dispLabel = selOpt ? selOpt.label : value;
      }
      return {
        label: filter.label ? filter.label : dispLabel,
        value
      };
  }
};

export const translateReportFilters = reportFilters =>
  reportFilters.map(filter => {
    const transValue = translateFilter(filter);
    return {
      id: filter.id,
      title: filter.name,
      mandatory: filter.isMandatory,
      componentType: filter.type,
      options: JSON.parse(filter.listData),
      ...transValue
    };
  });

export const translateSelectedFilters = (selectedFilters, reportFilters) => {
  return selectedFilters.map(andFilter => {
    return andFilter.map(orFilter => {
      const repFilter = reportFilters.find(f => f.id === orFilter.field);
      const transFilter = {
        type: repFilter.componentType,
        componentType: repFilter.componentType,
        value: orFilter.value
      };
      const fWithType = Object.assign({}, orFilter, transFilter, {
        options: repFilter.options
      });
      const valueMap = translateFilter(fWithType);
      const obj = Object.assign(
        { index: _.uniqueId('frule_') },
        orFilter,
        transFilter,
        valueMap
      );
      return obj;
    });
  });
};

export const translateFilterSummary = filters => {
  return filters.map(andFilter => {
    return andFilter.map(orFilter => {
      const valueMap = translateFilter(orFilter);
      const obj = Object.assign({}, orFilter, valueMap);
      return obj;
    });
  });
};

export const formatFilters = filters => {
  return filters.map(filter => formatFilter(filter));
};

export const formatFilterValueForAPI = filter => {
  let { value } = filter;

  if (value instanceof Array) {
    value = value.join('|');
  }

  return { value };
};

export const formatFiltersForAPI = filters => {
  return filters.map(filterSection =>
    filterSection.map(filter => Object.assign({}, filter, formatFilter(filter)))
  );
};



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/filters.js